<div
  appObserveResize
  (resized)="invalidateSize()"
  class="h-64 min-h-[6rem] resize-y overflow-auto border border-secondary"
>
  <div [id]="mapId" class="h-full"></div>
</div>
